import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';

export class GeolocationGetAddressFromCoordinatesRequestBody extends NaniumObject<GeolocationGetAddressFromCoordinatesRequestBody> {
	@Type(String) latitude: string;
	@Type(String) longitude: string;
	/**
	 * Optional language hint forwarded to Nominatim (`accept-language`).
	 * Defaults to `de` because the app is German-only today.
	 */
	@Type(String) language?: string;
}

/**
 * Compact, ready-to-render label for the resolved coordinate plus the
 * raw building blocks the UI may want to display individually.
 *
 * Filled best-effort: every individual field can be missing depending
 * on what Nominatim returns for the area (rural villages often lack a
 * `road`, big city centers may lack a `suburb`, etc.). The
 * `displayName` always contains a sensible short string assembled from
 * whatever was available.
 */
export class GeolocationGetAddressFromCoordinatesResponse extends NaniumObject<GeolocationGetAddressFromCoordinatesResponse> {
	@Type(String) displayName: string;
	@Type(String) road?: string;
	@Type(String) suburb?: string;
	@Type(String) city?: string;
}

@RequestType({
	responseType: GeolocationGetAddressFromCoordinatesResponse,
	genericTypes: { TRequestBody: GeolocationGetAddressFromCoordinatesRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class GeolocationGetAddressFromCoordinatesRequest extends ServiceRequestBase<GeolocationGetAddressFromCoordinatesRequestBody, GeolocationGetAddressFromCoordinatesResponse> {
	static serviceName: string = 'NaniumDemo:geolocation/getAddressFromCoordinates';
}
